export default __webpack_public_path__ + "static/media/SkyQ-Tech-Vertical-yellow.975ba0d4.svg";